import {Bag} from "../types/Bag";

export const getScore = (bags: Bag[]) =>
    bags.reduce((prev, current) => current.points ? current.points + prev : prev, 0);